"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var slideout_1 = __importDefault(require("../helpers/slideout"));
var utilities_1 = require("../helpers/utilities");
var accordion_1 = __importDefault(require("./accordion"));
var Filters = /** @class */ (function () {
    function Filters() {
        var _this = this;
        this.reinit = (0, utilities_1.debounce)(function () {
            if (!window.location.pathname.includes('collection'))
                return;
            document.querySelectorAll(_this.config.selectors.main).forEach(function (htmlElement) {
                _this.close();
                _this.load(htmlElement);
            });
        }, 250);
        this.config = {
            slideouts: [],
            isDesktop: null,
            dropdown: null,
            options: null,
            openBtn: null,
            selectors: {
                main: '[data-filters]',
                mobile: '[data-filters="mobile"]',
                desktop: '[data-filters="desktop"]',
                dropdown: '[data-filters-dropdown]',
                open: '[data-filters-open-btn]',
                close: '[data-filters-close-btn]',
                sortBy: '[data-sort-by-toggle]',
                option: '[data-filters-option]'
            },
            classNames: {
                open: 'filters--open',
                hide: 'hide'
            }
        };
    }
    Filters.prototype.init = function () {
        var _this = this;
        var filters = document.querySelectorAll(this.config.selectors.main);
        if (!window.location.pathname.includes('/collections/') || window.location.pathname.includes('/products/') && filters.length)
            return;
        filters.forEach(function (htmlElement) {
            _this.load(htmlElement);
        });
        document.querySelectorAll(this.config.selectors.open).forEach((function (filterBtn) {
            filterBtn.addEventListener('click', _this.handleOpenClick.bind(_this));
        }));
        document.querySelectorAll(this.config.selectors.close).forEach((function (filterBtn) {
            filterBtn.addEventListener('click', _this.handleCloseClick.bind(_this));
        }));
        document.querySelectorAll(this.config.selectors.sortBy).forEach((function (sortByBtn) {
            sortByBtn.addEventListener('click', _this.handleCloseClick.bind(_this));
        }));
    };
    Filters.prototype.load = function (node) {
        this.config.isDesktop = (0, utilities_1.isDesktop)();
        if (this.config.isDesktop) {
            this.config.slideouts.forEach(function (_slideout) { return slideout_1.default.destroy(_slideout); });
            this.config.slideouts = [];
            this.config.dropdown = document.querySelector(this.config.selectors.desktop);
        }
        else {
            this.config.slideouts.push(slideout_1.default.init(node));
            this.updateSortBy();
        }
    };
    Filters.prototype.reinit = function () {
        var _this = this;
        document.querySelectorAll(this.config.selectors.main).forEach(function (htmlElement) {
            _this.load(htmlElement);
        });
    };
    Filters.prototype.openDropdown = function (event) {
        var target = event.target;
        var open = target.closest(this.config.selectors.open);
        if (!open.classList.contains(this.config.classNames.open)) {
            var sortBy = document.querySelector('[data-sort-by-toggle]');
            this.config.dropdown.classList.add(this.config.classNames.open);
            open.classList.add(this.config.classNames.open);
            sortBy.classList.remove('accordion--active');
            accordion_1.default.load();
            return;
        }
        this.closeDropdown();
    };
    Filters.prototype.closeDropdown = function () {
        var _this = this;
        this.config.dropdown.classList.remove(this.config.classNames.open);
        document.querySelectorAll(this.config.selectors.open).forEach(function (htmlElement) { return htmlElement.classList.remove(_this.config.classNames.open); });
    };
    Filters.prototype.updateSortBy = function () {
        var currentSortBy = (0, utilities_1.getParameterByName)('sort_by');
        var sortBy = document.querySelector("[data-sort-by=\"".concat(currentSortBy, "\"]"));
        var accordion = null;
        if (sortBy)
            accordion = sortBy.closest('[data-accordion]'), sortBy.classList.add('selected');
        if (accordion)
            accordion.classList.add('accordion--active');
    };
    Filters.prototype.handleOpenClick = function (event) {
        event.preventDefault();
        this.open(event);
    };
    Filters.prototype.handleCloseClick = function (event) {
        event.preventDefault();
        this.close();
    };
    Filters.prototype.close = function () {
        if (!this.config.isDesktop) {
            this.config.slideouts.forEach(function (_slideout) { return _slideout.close(); });
        }
        else {
            this.closeDropdown();
        }
    };
    Filters.prototype.open = function (event) {
        if (!this.config.isDesktop) {
            this.config.slideouts.forEach(function (_slideout) { return _slideout.open(); });
        }
        else {
            this.openDropdown(event);
            accordion_1.default.load();
        }
    };
    return Filters;
}());
exports.default = new Filters();
